import { CoSyncInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import ipc, { IpcEvents } from './ipc';
import storage from './storage';
import { SystemSetting } from './storage/StoreKey';
import user from './user';

function getUserOrganizationId() {
  const userInfo = user.getUserInfo();
  return `${userInfo.userId}_${userInfo.organizationId}`;
}
export async function createSyncTaskLink(coSyncInfo: CoSyncInfo) {
  const ret = await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
    event: 'createSyncTaskLink',
    params: {
      syncPath: coSyncInfo.config.syncPath.localPath,
      userOrganizationId: getUserOrganizationId(),
    },
  });

  if (!ret) {
    // 创建快捷方式失败
    logger.ui.info('createSyncTaskLink create fail', coSyncInfo);
    return;
  }

  await checkSysSyncEntry();
}

export async function deleteSyncTaskLink(coSyncInfo: CoSyncInfo) {
  const ret = await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
    event: 'deleteSyncTaskLink',
    params: { syncPath: coSyncInfo.config.syncPath.localPath, userOrganizationId: getUserOrganizationId() },
  });

  if (!ret) {
    // 创建快捷方式失败
    logger.ui.info('deleteSyncTaskLink delete fail', coSyncInfo);
    return;
  }

  await checkSysSyncEntry();
}

export async function checkSysSyncEntry(isEmpty = false) {
  const storageSystemSetting = storage.get<SystemSetting>(storage.StoreKey.SYSTEM_SETTING);
  if (!storageSystemSetting.syncVirtualDisk) {
    removeSysSyncEntry();
    logger.ui.info('checkSysSyncEntry removeSysSyncEntry');
  } else {
    addSysSyncEntry();
    logger.ui.info('checkSysSyncEntry addSysSyncEntry');
  }
}

export async function addSysSyncEntry() {
  logger.ui.info('addSysSyncEntry');
  await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
    event: 'addSysSyncEntry',
    params: { userOrganizationId: getUserOrganizationId() },
  });
}

export async function removeSysSyncEntry() {
  logger.ui.info('removeSysSyncEntry');
  await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
    event: 'removeSysSyncEntry',
  });
}
